<template>
    <comp-9-art-adherence :section="9" :page="71" :nextDisabled="nextDisabled">
        <p>
            Nice work! You can see the links to the resources we just covered on the Resources screen.
        </p>
        <div v-if="showReminderReminder">
            <p>
                You said you could use a reminder to help you remember to take your medication regularly. Did you really set a reminder? Setting a reminder has
                helped both CJ and Billie remember to take their meds.
            </p>
            <v-radio-group v-model="artReminderSelection" column>
                <v-radio v-for="reminder in artReminders" :key="reminder.id" :label="reminder.text" :value="reminder"></v-radio>
            </v-radio-group>
        </div>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            artReminderSelection: null
        };
    },
    computed: {
        artReminder() {
            let selectedArtReminder = find(this.artReminders, 'selected');

            if (selectedArtReminder) {
                return selectedArtReminder;
            } else return null;
        },
        showReminderReminder() {
            let reminderStrategies = filter(filter(this.$store.get('section9/artRegularStrategiesRevisited'), 'selected'), 'reminderStrategy');

            if (reminderStrategies.length > 0) {
                return true;
            }

            return false;
        },
        artReminders: sync('section9/artReminder')
    },
    methods: {
        nextDisabled() {
            return this.showReminderReminder && !this.artReminderSelection;
        }
    },
    watch: {
        artReminderSelection(newArtReminderSelection) {
            forEach(this.artReminders, o => {
                if (o.id === newArtReminderSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.artReminderSelection = this.artReminder;
    }
};
</script>
